import { compose } from 'redux'

import {
  assignChildToParent,
  getAllAncestorsForItem,
  getAllDescendantsForItem,
  getTreeItemState,
  IDataShape,
  mapDataShapeToTreeStructure,
} from 'cng-common/components/treeSelect'
import { ITreeStructure } from 'cng-common/components/treeSelect/models/treeStructure'
import { Nullable } from 'cng-common/models/utils'
import { Crud } from 'core/types/Crud'

interface IMappedDataModel extends IDataShape {
  name: Nullable<string>
}

interface IDataModelShape {
  Id: string
  ParentId: Nullable<string>
  Name: Nullable<string>
}

interface IGetNestedIdsParams<T> {
  values: string[]
  crud: Crud<T>
}

export const getNestedIds = <T extends IDataModelShape>({
  values,
  crud,
}: IGetNestedIdsParams<T>) => {
  const data = crud.getDataFromStore().map<IMappedDataModel>((it) => ({
    itemId: it.Id,
    parentId: it.ParentId,
    name: it.Name,
  }))

  const flatData = compose(assignChildToParent, mapDataShapeToTreeStructure<IMappedDataModel>)(
    data,
    {
      itemCaption: 'name',
    }
  )

  return flatData
    .filter((it) => values.some((selectedId) => selectedId === it.itemId))
    .reduce<ITreeStructure[]>(
      (acc, item) => [...getAllAncestorsForItem(item), ...getAllDescendantsForItem(item), ...acc],
      []
    )
    .map<ITreeStructure>((it, i, origin) => ({
      ...it,
      checkedState: getTreeItemState(it.itemId, flatData, origin),
    }))
    .map((it) => it.itemId.toString())
}
